 import React, { useEffect, useState  } from 'react';
 import{Button} from '@progress/kendo-react-buttons';
import img2 from '../images/appForm.png';
import imgpdfD from '../images/icon_pdf.png';
import '../Card/card-style.css';
import fantasticSubmitData from '../data/fantasticsubmit.json'
import storage from '../factory/StorageFactory';
import FormContainer from '../components/FormContainer';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import helper from '../factory/Helper.js';

const fsaData = fantasticSubmitData;

const Submit = props => {
    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);

    const [refNo, setRefNo] = useState('');

    useEffect(() => {
      
        window.scrollTo(0,0);
        setRefNo(storage.getRefNo());

        clearData();
     }, []);

    

    const clearData =()=> {
        if(storage.getStateId() !== null){
            storage.clearAll();
        }
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('Submit');
        return url;
    }

    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
          paperSize: 'auto',
          margin: 5,
          fileName:refNo+'.pdf',
          proxyUrl:getProxyUrl()
        });
      };
    
    const exportPDFWithComponent = () => {
        if (pdfExportComponent.current) {
          pdfExportComponent.current.save();
        }
    };

    const printPDF = () => {
        window.print();
    }

    return(
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={refNo+'.pdf'}> 
        <div><br/>
        <div className="k-align-items-center">            
            <p className="bgtxt">{fsaData.formContainerTitle[0].name}</p> 
            <p className="sbgtxt">{fsaData.formContainerTitle[1].name}</p>
        </div> 
        
          <FormContainer>
            <div>
                <div className="smTxt"> 
                    <div style={{fontSize:"1.2em",fontWeight:'500'}}>{'Thanks! We will review your application.'}</div><br/>
                    <div>{'This usually takes around an hour, sometimes up to 2 days.'}</div>
                    <div>{'We will get in touch with you.'}</div>
                    <div style={{paddingTop:'10px'}}>{fsaData.cardLabel.header}<span style={{fontWeight:'500'}}>{refNo}</span></div>
                </div> 
                <div style={{textAlign:'center'}}>
                    <img className="imgScc" src={img2} alt="imgScc"></img>
                </div>
                <br/>
              
            </div>
          
            <div style={{paddingBottom:'20px'}}> <hr className="lightgreyPanelLine" /> </div>
            <div  style={{ textAlign: "center", display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap',paddingBottom:'30px' }}>
                <div className="sccbtMid">
                <Button look="outline" className="btSize2 btLft2" onClick={exportPDFWithComponent}>                                                                                   
                    <img className="img-fluid" src={imgpdfD} alt="imgpdfD"></img>
                    {fsaData.cardLabel.btnSave}
                </Button>                                
                {/* <Button look="outline"  className="btSize2 btRht3" onClick={printPDF}>
                    <img className="img-fluid" src={imgPrint} alt="imgPrint"></img>
                    {fsaData.cardLabel.btnPrint}                                   
                </Button> */}
                </div> 
            </div>
 
            </FormContainer>
        </div>
        </PDFExport>
    );
}

export default Submit;